module.exports = __webpack_public_path__ + "img/create-the-future.b0d0ab11.jpg";